// extracted by mini-css-extract-plugin
module.exports = {"container":"Demo_container__3hxyt","limiter":"Demo_limiter__pymzk","wrapper":"Demo_wrapper__1gYxs"};